<template>
  <main class="admin-articles">
    <div class="admin-articles__wrapper">
      <h1 class="admin-articles__page-title">Статьи</h1>
      <div class="admin-articles__articles-list">
        <router-link
          v-for="(article, index) in articles"
          :key="index"
          class="admin-articles__article"
          tag="div"
          :to="{ name: 'AdminArticleEdit', params: { id: article.id } }"
        >
          <div class="admin-articles__image-wrapper">
            <img class="admin-articles__cover" :src="article.preview.url" :alt="article.previewText">
            <div class="admin-articles__overlay"></div>
          </div>
          <pre class="admin-articles__article-title">{{ article.previewText }}</pre>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import { apiGetAllArticles } from '../utils/api' 

export default {
  name: 'AdminArticles',
  data() {
    return {
      articles: []
    }
  },
  async mounted() {
    try {
      this.articles = await apiGetAllArticles()
    } catch(e) {
      console.error(e.message)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.admin-articles {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px 45px 0;
  &__wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1328px;
  }
  &__page-title {
    font-size: 22px;
    line-height: 40px;
    text-transform: uppercase;
    margin-bottom: 50px;
  }
  &__articles-list {
    flex-grow: 1;
    display: grid;
    grid-template-columns: 400px 400px;
    grid-template-rows: 100%;
    column-gap: 40px;
    height: 100%;
  }
  &__article {
    cursor: pointer;
  }
  &__article:hover &__overlay {
    opacity: 0.4;
  }
  &__image-wrapper {
    position: relative;
    height: 70%;
    margin-bottom: 30px;

  }
  &__cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: colors.$grayef;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0;
    transition: 200ms all ease;
  }
  &__article-title {
    @include fonts.ap-reg;
    font-size: 20px;
    line-height: 26px;
  }
}

@media screen and (max-width: 1024px) {
  .admin-articles {
    padding-top: 50px;
    &__page-title {
      margin-bottom: 25px;
    }
  }
}

@media screen and (max-width: 930px) {
  .admin-articles {
    padding: 50px 12px 40px;
    &__articles-list {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      row-gap: 30px;
    }
    &__image-wrapper {
      position: relative;
      height: auto;
      padding-bottom: 120%;
      margin-bottom: 30px;

    }
    &__cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0;
      transition: 200ms all ease;
    }
    &__article-title {
      @include fonts.ap-reg;
      font-size: 20px;
      line-height: 26px;
    }
  }
}
</style>